import { useLocation } from "@reach/router"

const usePage = path => {
  const { pathname } = useLocation()

  return pathname === path
}

export default usePage
